import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { mask } from "vue-the-mask";

import ModalBase from "../modalBase/modalBase";

@Component({
  directives: { mask },
  components: {
    ModalBase,
  },
})
export default class ModalCreditCardNew extends Vue {
  @Prop({ default: false }) isActive;

  @Action action_createCreditCard;
  @Action action_getAcceptanceToken;

  @Getter getAcceptanceToken;

  @Mutation CURRENT_PAYMENT_METHOD;

  formData = {
    name: "",
    mex_address: "",
    credit_card_number: "",
    ccv: "",
    expiration_date: "", // TODO: DELETE THIS VARIABLE
    expiration_mounth: "",
    expiration_year: "",
    doc_type: "CC",
    doc_number: "",
  };
  isLoading = false;
  error = "";
  isWompiContract = false;
  errors = [];

  async mounted() {
    if (!this.getAcceptanceToken) {
      await this.action_getAcceptanceToken();
    }
  }

  cc_format() {
    this.formData.credit_card_number = this.formData.credit_card_number.replace(/\D/g, "");
    let v = this.formData.credit_card_number.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    let matches = v.match(/\d{4,16}/g);
    let match = (matches && matches[0]) || "";
    let parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      this.formData.credit_card_number = parts.join(" ");
    } else {
      this.formData.credit_card_number = this.formData.credit_card_number;
    }
  }

  validateForm() {
    this.errors = [];
    this.error = "";

    if (!this.formData.name || !this.formData.name.length) {
      this.errors.push("name");
    }
    if (!this.formData.doc_type || !this.formData.doc_type.length) {
      this.errors.push("doc_type");
    }
    if (!this.formData.doc_number || !this.formData.doc_number.length) {
      this.errors.push("doc_number");
    }
    if (!this.formData.credit_card_number || !this.formData.credit_card_number.length) {
      this.errors.push("credit_card_number");
    }
    if (!this.formData.expiration_mounth || !this.formData.expiration_mounth.length) {
      this.errors.push("expiration_month");
    }
    if (!this.formData.expiration_year || !this.formData.expiration_year.length) {
      this.errors.push("expiration_year");
    }
    if (!this.formData.ccv || !this.formData.ccv.length) {
      this.errors.push("cvv");
    }
  }

  isError(value) {
    let response = false;
    const findIndex = this.errors.findIndex((error) => error === value);
    if (findIndex !== -1) {
      response = true;
    }
    return response;
  }

  async submitCreditCard() {
    if (this.isWompiContract) {
      this.validateForm();
      if (this.errors.length === 0) {
        try {
          this.isLoading = true;
          // validamos si el usuario escribio bien la fecha de expiración
          this.formData.credit_card_number = this.formData.credit_card_number.replace(/ /g, "");
          if (
            this.formData.expiration_year.length < 2 ||
            this.formData.expiration_year.length >= 3
          ) {
            this.error = "Ingresa la fecha en formato ‘01/25’";
          } else {
            this.error = "";
            this.formData.expiration_year = `20${this.formData.expiration_year}`;
            this.formData.expiration_mounth =
              this.formData.expiration_mounth.length === 1
                ? `0${this.formData.expiration_mounth}`
                : this.formData.expiration_mounth;
            const expiration_date = `${this.formData.expiration_mounth}/${this.formData.expiration_year}`;
            let res = null;
            const acceptance_token = (this.getAcceptanceToken as any).acceptance_token;
            res = await this.action_createCreditCard({
              credit_card: { ...this.formData, expiration_date, acceptance_token },
            });

            if (res && res.data && res.data.credit_card_number) {
              const newCard = res.data;
              const payment = {
                type: "credit_card",
                card: newCard,
                value: newCard.credit_card_number,
              };
              this.CURRENT_PAYMENT_METHOD(payment);
              this.$emit("set-payment-method", payment);
            }
            this.$emit("modal-close");
            this.isLoading = false;
            this.$swal({
              imageUrl: "/assets/images/ui/cohete.png",
              imageWidth: 100,
              title: "Tu tarjeta de crédito ha sido agregada correctamente",
              showConfirmButton: false,
              timer: 1500,
            });
            this.isWompiContract = false;
          }
        } catch (error) {
          this.isLoading = false;
          let error_message = error.response && error.response.data && error.response.data.message;
          this.error = error_message ? error_message : "Error agregando tarjeta de crédito";
          this.$swal({
            title: "Error al agregar tarjeta.",
            text: `Error: ${this.error}`,
          });
          this.isWompiContract = false;
        }
      } else {
        this.error = "Por favor, completa todos los campos.";
      }
    } else {
      this.error =
        "Debes aceptar los términos y condiciones para poder agregar la tarjeta de crédito";
    }
  }
}
